import { render, staticRenderFns } from "./wallRating.vue?vue&type=template&id=34a5bfeb&scoped=true"
import script from "./wallRating.vue?vue&type=script&lang=js"
export * from "./wallRating.vue?vue&type=script&lang=js"
import style0 from "./wallRating.vue?vue&type=style&index=0&id=34a5bfeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a5bfeb",
  null
  
)

export default component.exports